import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LogIn } from 'lucide-react';

/**
 * Session expired dialog
 * Shown when a 401 response is received from the API,
 * prompting the user to sign in again.
 */
export function SessionExpiredDialog() {
  const navigate = useNavigate();
  const { sessionExpired, setSessionExpired } = useAuthStore();

  const handleSignIn = () => {
    setSessionExpired(false);
    navigate('/sign-in', { state: { from: window.location.pathname } });
  };

  const handleDismiss = () => {
    setSessionExpired(false);
    navigate('/');
  };

  return (
    <Dialog open={sessionExpired} onOpenChange={(open) => !open && handleDismiss()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LogIn className="h-5 w-5 text-[#00139e]" />
            Session Expired
          </DialogTitle>
          <DialogDescription>
            Your session has expired. Please sign in again to continue where you left off.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-row">
          <Button variant="outline" onClick={handleDismiss} className="rounded-full">
            Go Home
          </Button>
          <Button
            onClick={handleSignIn}
            className="rounded-full bg-[#1d2fb5] hover:bg-[#1728a0] text-white"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Sign In
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
